/* KTZ · «Seguir comprando» del carrito vacio regresa a la pagina ANTERIOR.
   🔒 Lalo, 7 sep 2026: "no a home ni a todos los productos".

   No es un `history.back()` a secas porque falla justo en los casos que importan:
     · llegar al carrito DIRECTO (marcador, correo, tras vaciarlo) -> "atras"
       saca del sitio;
     · si la anterior era el propio carrito (recarga) -> bucle;
     · el mismo boton vive tambien en el CAJON lateral, donde lo correcto es
       CERRARLO, no navegar.
   El `href` original queda intacto como respaldo: si nada de esto aplica, el
   boton hace lo de siempre. */
(function () {
  'use strict';

  function esDelSitio(url) {
    try { return new URL(url, location.href).origin === location.origin; }
    catch (e) { return false; }
  }

  /* 🔑 Generalizado 〔7 sep 2026〕: antes solo excluia el carrito. Ahora excluye
     LA PAGINA ACTUAL, sea la que sea — si el referente es esta misma pagina
     (una recarga, o llegar de /pages/videos a /pages/videos) volver seria un
     bucle. Sirve igual para «Seguir comprando» del carrito y para «Tienda» del
     feed de videos, sin duplicar la logica. */
  function esLaMisma(url) {
    try { return new URL(url, location.href).pathname === location.pathname; }
    catch (e) { return false; }
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('[data-ktz-volver]') : null;
    if (!a) return;

    // 1) Dentro del cajon: cerrar, no navegar.
    var cajon = a.closest('cart-drawer-component, dialog, [class*="cart-drawer"]');
    if (cajon) {
      var dlg = cajon.matches && cajon.matches('dialog') ? cajon : cajon.querySelector('dialog');
      if (typeof cajon.closeDialog === 'function') { ev.preventDefault(); cajon.closeDialog(); return; }
      if (dlg && typeof dlg.close === 'function') { ev.preventDefault(); dlg.close(); return; }
    }

    // 2) Hay una pagina anterior nuestra que no es el carrito: volver a ella.
    var ref = document.referrer;
    if (ref && esDelSitio(ref) && !esLaMisma(ref) && history.length > 1) {
      ev.preventDefault();
      history.back();
      return;
    }

    // 3) Si no, se deja pasar el clic: el href de siempre.
  }, true);
})();
